import { axiosInstance as axios } from '@/services'
import type { User } from '../types'

const LEGAL_DOCUMENTS_API = import.meta.env.VITE_LEGAL_DOCUMENTS_API_URL

export type LoginParams = {
  email: string
  password: string
}

export type AutoLoginParams = {
  key: unknown
  organization: unknown
}

export type LostPasswordParams = {
  email: string
}

export interface AutoLoginResponse {
  error: boolean
  use_autologin?: boolean
  data: User
}

export const userLogin = (params: LoginParams): Promise<{ data: User }> => {
  return axios.post(`/login/`, params)
}

export const sendLostPasswordEmail = (params: LostPasswordParams) => {
  return axios.post('/password/request_reset/', params)
}

export const userAutoLogin = (params: AutoLoginParams): Promise<{ data: AutoLoginResponse }> => {
  const endpoint = `/autologin/?organization_id=${params.organization}&key=${params.key}`

  return axios.get(endpoint)
}

export const userHasTyCPPSigned = (user_id: number) => {
  return axios.get(
    `${LEGAL_DOCUMENTS_API}/v1/legal-documents/documents/check-signature/?user_id=${user_id}&origin=PARTNERS`
  )
}

export const policyVersions = () => {
  return axios.get(`${LEGAL_DOCUMENTS_API}/v1/legal-documents/documents/latest/?origin=PARTNERS`)
}

export type SignPolicyParams = {
  user_id: number
  document_hashes: string[]
  origin: string
}

export const signPolicy = (params: SignPolicyParams) => {
  return axios.post(`${LEGAL_DOCUMENTS_API}/v1/legal-documents/documents/sign/`, params)
}

export type AcceptPolicyParams = {
  user_id: number
  policy: string
  version: string
  origin: string
}

export const acceptPolicy = (params: AcceptPolicyParams) => {
  return axios.post('/accept-policy/', params)
}

export type ChangePasswordParams = {
  new_password: string
  current_password?: string
  last_login: string | null
}

export const changePassword = (params: ChangePasswordParams) => {
  return axios.post('/password/change/', params)
}
